export type CustomItemGroupModel = {
  agency_id: number,
  cache_key: number,
  id: number,
  title: string,
}

export type CustomItemGroupRequestOptions = {}

const state = {
  agency_id: null,
  id: null,
  title: '',
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'title' },
]

export default state
